import { type HeatMap } from '~/_shared/types/heatmap/heatMap.types';
import { type MapSettingsHeatmapsResponse } from '~/map/map.repository';
import { mapSettingsHeatmapsInitialState } from './mapSettingsHeatmaps.reducer';
import { type MapSettingsHeatmapsState } from './mapSettingsHeatmaps.state';

export const mapSettingsHeatmapSerializer = {
  jsonToState: (json: MapSettingsHeatmapsResponse): MapSettingsHeatmapsState => {
    const { heatmaps: jsonHeatmaps, ...rest } = json;

    const state: MapSettingsHeatmapsState = {
      ...mapSettingsHeatmapsInitialState,
      ...rest,
    };

    if (jsonHeatmaps) {
      state.heatmaps = jsonHeatmaps.map(heatMap => {
        const { selectedGroup, colors, denseColor, mediumColor, lightColor, ...rest } = heatMap;

        return {
          ...rest,
          // backward compatibility with old model for light, medium, and dense colors
          colors: colors ?? [lightColor ?? '', mediumColor ?? '', denseColor ?? ''],
          ...(selectedGroup && {
            // backward compatibility with old model
            // TODO: remove after beta
            selectedGroupId: selectedGroup,
            selectedGroupName: selectedGroup,
          }),
        };
      }) as unknown as ReadonlyArray<HeatMap>;

    }

    return state;
  },
  stateToJson: (state: MapSettingsHeatmapsState): MapSettingsHeatmapsResponse => {
    return state;
  },
};
